var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweetBellPeppers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.713,
    height: 15.638,
    viewBox: "0 0 23.713 15.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(1.35 0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3199",
    "data-name": "Group 3199",
    transform: "translate(-1 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M809.688,216.771q-.614,0-1.231-.053a16.758,16.758,0,0,1-5.66-1.563,19.97,19.97,0,0,1-5.25-3.532l-1.593-1.593a2.791,2.791,0,0,1-.374-.464.35.35,0,1,1,.589-.378,2.089,2.089,0,0,0,.28.347l1.593,1.592a19.652,19.652,0,0,0,5.072,3.4,16.046,16.046,0,0,0,5.416,1.491,13.641,13.641,0,0,0,6.541-1.063.1.1,0,0,0,.066-.107.087.087,0,0,0-.077-.082,16.919,16.919,0,0,1-4.719-1.65,23.018,23.018,0,0,1-6.606-5.471c-.9-1.046-1.726-1.945-2.529-2.747l-.063-.063a2.1,2.1,0,0,0-.341-.275.35.35,0,0,1,.38-.588,2.81,2.81,0,0,1,.456.368l.063.063c.815.815,1.654,1.726,2.564,2.786a22.327,22.327,0,0,0,6.4,5.307,16.259,16.259,0,0,0,4.533,1.584.782.782,0,0,1,.633.7.8.8,0,0,1-.489.821A14.387,14.387,0,0,1,809.688,216.771Z",
    transform: "translate(-792.475 -201.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M796.895,201.161a3.841,3.841,0,0,1,2.38.884.35.35,0,0,1-.179.606,2.466,2.466,0,0,0-1.463.9,2.269,2.269,0,0,0-.27,1.78.35.35,0,0,1-.41.41,3.305,3.305,0,0,0-.626-.064,2.116,2.116,0,0,0-2.054,1.8.35.35,0,0,1-.606.178,3.907,3.907,0,0,1-.792-1.593,3.719,3.719,0,0,1,1.212-3.6A3.946,3.946,0,0,1,796.895,201.161Zm1.344,1.038a2.992,2.992,0,0,0-1.344-.338,3.276,3.276,0,0,0-2.314,1.1,3.057,3.057,0,0,0-1.025,2.942,3.2,3.2,0,0,0,.264.718,3.254,3.254,0,0,1,.239-.437,2.586,2.586,0,0,1,2.268-1.205q.139,0,.283.011a2.746,2.746,0,0,1,.453-1.844A2.865,2.865,0,0,1,798.238,202.2Z",
    transform: "translate(-790.522 -199.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M786.792,198.045a.35.35,0,0,1-.332-.238,2,2,0,0,0-1.67-1.359,1.1,1.1,0,0,1-.988-.7l0,0,0-.009-.009-.025a1.078,1.078,0,0,1,.175-1.041,1.109,1.109,0,0,1,1-.418,4.033,4.033,0,0,1,3,2.405.35.35,0,1,1-.616.333,3.367,3.367,0,0,0-2.469-2.043.414.414,0,0,0-.373.157.382.382,0,0,0-.065.369l.008.021a.4.4,0,0,0,.358.251,2.694,2.694,0,0,1,2.312,1.837.35.35,0,0,1-.332.461Z",
    transform: "translate(-784.074 -194.596)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweetBellPeppers);
export default __webpack_public_path__ + "static/media/sweet_bell_peppers.12c81e22d279a3beebcef13875d34c82.svg";
export { ForwardRef as ReactComponent };